import React from "react"
import { Link } from "gatsby"
import { logout } from "../utils/auth"

import { BurgerIcon, CrossIcon } from "./contactIcons"

export class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpened: false,
      currentTab: "Home",
    }
  }

  handleClose = () =>
    this.setState({ isOpened: false }, console.log(this.state))
  handleOpen = () => this.setState({ isOpened: true }, console.log(this.state))

  currentActiveTab = name => {
    console.log(name)
    this.setState({ currentTab: name })
  }

  renderLinks = (links, onClick) => {
    return links.map(link => {
      return (
        <Link
          className={`navbar__desktop-item ${
            this.state.currentTab === link.name ? "navbar__desktop-active" : ""
          }`}
          key={link.to}
          to={link.to}
          title={link.name}
          onClick={() => {
            onClick(link.name)
          }}
        >
          {link.name}
        </Link>
      )
    })
  }

  render() {
    const links = [
      { name: "Live Stream", to: "#live" },
      { name: "Experiences + Schedule", to: "#liveexperience" },
      { name: "Logout", to: "/logout" },
    ]
    return (
      <div className="navbar">
        <div className="container">
          <div className="logo">
            <a href="/">
              <img className="logo__image" src="./logo.svg" />
            </a>
          </div>
          <div className="navbar__wrapper">
            <button
              className="navbar__mobile-menu"
              onClick={this.handleOpen}
              tabIndex={0}
            >
              <BurgerIcon />
            </button>

            <nav
              className={`navbar__mobile ${
                this.state.isOpened ? "navbar__mobile-isOpened" : null
              }`}
            >
              {this.renderLinks(links, this.currentActiveTab)}
              <button
                className="navbar__mobile-menu"
                onClick={this.handleClose}
                tabIndex={0}
              >
                <CrossIcon />
              </button>
            </nav>

            <nav className="navbar__desktop">
              {this.renderLinks(links, this.currentActiveTab)}
            </nav>
          </div>
        </div>
      </div>
    )
  }
}
